import { useEffect, useState } from 'react';
import { api, type AuditEntry } from '@/api/client';
import { ErrorBox, Loading, PageTitle } from '@/components/ui';

export function AuditPage() {
  const [items, setItems] = useState<AuditEntry[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api.audit().then(({ items }) => setItems(items)).catch((e) => setErr(String(e)));
  }, []);

  if (err) return <ErrorBox text={err} />;
  if (!items) return <Loading />;

  return (
    <div>
      <PageTitle title="Audit Log" />
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table className="data">
          <thead>
            <tr>
              <th>When</th>
              <th>Actor</th>
              <th>Action</th>
              <th>Target</th>
              <th>Payload</th>
            </tr>
          </thead>
          <tbody>
            {items.map((e) => (
              <tr key={e.id} style={{ cursor: 'default' }}>
                <td className="mono" style={{ fontSize: 11, color: 'var(--ink-muted)' }}>
                  {new Date(e.createdAt).toLocaleString()}
                </td>
                <td>
                  <div style={{ fontWeight: 600 }}>{e.actor.displayName}</div>
                  <div className="mono" style={{ fontSize: 10, color: 'var(--ink-dim)' }}>
                    {e.actor.email ?? e.actor.id}
                  </div>
                </td>
                <td className="mono" style={{ color: 'var(--c-cyan)' }}>{e.action}</td>
                <td className="mono" style={{ fontSize: 11, color: 'var(--ink-muted)' }}>
                  {e.target ?? '—'}
                </td>
                <td>
                  <pre
                    style={{
                      margin: 0,
                      fontSize: 10,
                      fontFamily: 'var(--f-mono)',
                      color: 'var(--ink-dim)',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-all',
                      maxWidth: 280,
                      maxHeight: 80,
                      overflow: 'auto',
                    }}
                  >
                    {e.payload ? JSON.stringify(e.payload, null, 1) : '—'}
                  </pre>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
